module.exports = __webpack_public_path__ + "static/img/Taylor_Adams_mobile.8fbe562.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/Taylor_Adams_mobile.jpg
// module id = tpAo
// module chunks = 0